import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
    message: {
        margin: theme.spacing(2),
    },
}));
